export function percentToRGB(percent) {
  if (percent === 100) {
    percent = 99;
  }
  var r, g, b;

  if (percent < 50) {
    // green to yellow
    r = Math.floor(255 * (percent / 50));
    g = 255;
  } else {
    // yellow to red
    r = 255;
    g = Math.floor(255 * ((50 - (percent % 50)) / 50));
  }
  b = 0;

  return [r, g, b];
}

export function getFontColorFromHex(hexcolor) {
  if (hexcolor.indexOf("#") >= 0) hexcolor = hexcolor.replace("#", "");
  var r = parseInt(hexcolor.substr(0, 2), 16);
  var g = parseInt(hexcolor.substr(2, 2), 16);
  var b = parseInt(hexcolor.substr(4, 2), 16);
  var yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 128 ? "black" : "white";
}
